package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.Inventory2W500Rounded: ImageVector
    get() {
        if (_inventory2W500Rounded != null) {
            return _inventory2W500Rounded!!
        }
        _inventory2W500Rounded = Builder(name = "Inventory2W500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(202.87f, 888.13f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                lineTo(111.87f, 347.8f)
                quadToRelative(-18.24f, -12.43f, -29.12f, -31.48f)
                quadToRelative(-10.88f, -19.06f, -10.88f, -43.02f)
                verticalLineToRelative(-110.43f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                reflectiveQuadToRelative(64.39f, -26.61f)
                horizontalLineToRelative(634.26f)
                quadToRelative(37.78f, 0.0f, 64.39f, 26.61f)
                reflectiveQuadToRelative(26.61f, 64.39f)
                verticalLineToRelative(110.43f)
                quadToRelative(0.0f, 23.96f, -10.88f, 43.02f)
                quadToRelative(-10.88f, 19.05f, -29.12f, 31.48f)
                verticalLineToRelative(449.33f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(202.87f, 888.13f)
                close()
                moveTo(202.87f, 364.3f)
                verticalLineToRelative(433.07f)
                horizontalLineToRelative(554.5f)
                lineTo(757.37f, 364.3f)
                horizontalLineToRelative(-554.5f)
                close()
                moveTo(162.87f, 273.3f)
                horizontalLineToRelative(634.5f)
                verticalLineToRelative(-110.43f)
                horizontalLineToRelative(-634.5f)
                verticalLineToRelative(110.43f)
                close()
                moveTo(399.04f, 565.74f)
                lineTo(561.2f, 565.74f)
                quadToRelative(18.19f, 0.0f, 30.65f, -12.46f)
                quadToRelative(12.45f, -12.45f, 12.45f, -30.65f)
                reflectiveQuadToRelative(-12.45f, -30.65f)
                quadToRelative(-12.46f, -12.46f, -30.65f, -12.46f)
                lineTo(399.04f, 479.52f)
                quadToRelative(-18.19f, 0.0f, -30.65f, 12.46f)
                quadToRelative(-12.46f, 12.45f, -12.46f, 30.65f)
                reflectiveQuadToRelative(12.46f, 30.65f)
                quadToRelative(12.46f, 12.46f, 30.65f, 12.46f)
                close()
                moveTo(480.24f, 580.72f)
                close()
            }
        }
        .build()
        return _inventory2W500Rounded!!
    }

private var _inventory2W500Rounded: ImageVector? = null
